import styles from './deployToken.module.css'
const deployTokenStyles = {
    outerContainer: `flex flex-col gap-[30px] container pb-2 ${styles.outerContainer}`,
    heading: `text-primaryHeading font-Suisse text-[16px] md:text-[24px] font-[700] text-center uppercase
              md:text-[20px]`,
    componentsContainer: `flex flex-col items-center gap-[30px]
                          lg:flex-row md:items-stretch 
    `,
    colContainer: `flex flex-col gap-[30px] w-[100%]
                   lg:w-1/2
    `,
    rowContainer: `flex flex-col gap-[30px] w-[100%] 
                   md:flex-row
                   lg:w-1/2
    `,
}


const previewGameStyles = {
    outerContainer: `relative rounded-[10px] overflow-hidden`, 
    court: `w-full h-full object-cover`,
    groupButton: 'absolute top-3 left-5 h-[35px] w-[35px] sm:h-[50px] sm:w-[50px] bg-primaryHeading rounded-full flex items-center justify-center cursor-pointer',
    groupIcon:` w-[20px] h-[20px] sm:w-[30px] sm:h-[30px]`,
}


const tokenSelectorStyles = {
    // outerContainer: `relative rounded-[10px] p-[25px] bg-[rgba(255,255,255,0.11)]`,
    outerContainer:`flex items-center justify-start w-full overflow-hidden gap-2 bg-[rgba(255,255,255,0.11)] px-[15px] py-[29px] rounded-[10px]
                    md:px-[26px]
    `,
    scrollButton: `absolute top-1/2 transform -translate-y-1/2 bg-themeColor p-2 rounded-full z-20 h-[110px] `,
    disabledButton: `opacity-50 cursor-not-allowed`,
    scrollableDiv: `flex gap-4 overflow-x-auto scrollbar-hide scroll-smooth w-[100%] lg:w-[700px]`,
    tokenDataContainer: `relative bg-themeColor border-[2px] border-transparent p-2 rounded-[10px] min-w-[130px] max-w-[130px] min-h-[130px] max-h-[130px] cursor-pointer hover:border-primaryHeading`,
    selectedtokenDataContainer: `border !border-primaryHeading`,
    tokenNumber: `absolute rounded-[25px] shadow-[0_0_0_0.12px_#fff] text-center text-[10px] leading-[14px] font-[500] whitespace-nowrap px-1 top-1 left-1`,
    imageContainer: `relative flex justify-center items-center h-full w-full`,
    actionImageWrapper: `relative w-[30px] h-[30px] rounded-[4px] overflow-hidden`,
    selectionContainer: `absolute bottom-0 right-1 flex flex-row-reverse gap-2`,
    imageText: `absolute bottom-[2px] left-1/2 transform -translate-x-1/2 whitespace-nowrap text-[3.5px] capitalize z-[2]`,
    tokenImage: `object-cover w-full h-auto max-w-[75px]`,
    deployedtokenImage: ` w-full h-[auto] max-w-[155px]`,
    actionImage: `h-[inherit] w-[inherit] object-cover object-top`,
    chevron_icon: `p-3 hover:text-gray-300`,
    chevron_container: `flex items-center justify-center h-[110px] w-[40px] bg-themeColor rounded-full cursor-pointer
                        md:max-w-[30px]
    `,
}


const previewTokenStyles = {
    outerContainer: `h-full rounded-[10px] p-2 flex justify-center`,
    innerContainer: `relative`,
    preview_token_zone: `min-h-[200px] max-h-[365px]`, 
    figureContainer: `absolute bottom-1/4 right-20 transform -translate-x-1/2 -translate-y-1/2 ${styles.beforeShadow}`,
}  


const selectActionAndPlayerStyles = {
    outerContainer: `flex flex-col justify-between w-full px-[15px] py-[29px] gap-[15px] h-full rounded-[10px] bg-[rgba(255,255,255,0.11)]
                    md:px-[26px]`,
    topContainer: `flex justify-between items-center`,
    stepNumber: `bg-themeColor border-lightborderColor border-[0.2px] whitespace-nowrap rounded-[140px] min-w-[90px] flex items-center justify-center text-center text-[12px] px-[10px] py-[4px] py-[6px]
                 md:text-[16px] md:px-[24px]`,
    heading: `font-Suisse text-[15px] text-center capitalize
              md:text-[18px] hidden 
              sm:block`,
    subHeading: `block text-center font-[600] text-[16px] font-Suisse sm:hidden`,
    backButton:`w-[80px] h-[25px] !py-[15px] 
                md:w-[90px] md:h-[35px] !md:py-0`,
    backButtonText:`text-[12px] 
                    md:text-[16px]`,
    dynamicButton: `h-[25px]  md:h-[35px] !py-[15px] !md:py-0`,
    buttonText: `text-[12px] md:text-[16px]`,
    buttonContainer: `flex justify-between`,
    selection: `flex flex-wrap gap-[8px] max-h-[350px] h-full rounded-[10px] overflow-auto`,
    imageContainer: `relative flex justify-between min-w-[160px] max-w-[170px] min-h-[160px] max-h-[170px] rounded-[10px] overflow-hidden border-[2px] border-transparent cursor-pointer ${styles.imageContainer}
                    md:w-full 
                    hover:border-primaryHeading
    `,
    image: `object-cover w-[inherit] h-[inherit] object-top`,
    selectedImage: `border-2 !border-primaryHeading`,
    disableImage: `hover:border-transparent opacity-50`,
    imageText: `absolute bottom-2 left-1/2 transform -translate-x-1/2 whitespace-nowrap capitalize text-[14px] 
                sm:text-[14px]
    `,
}

const poweredUpScreen ={
    outerContainer: `flex flex-col w-full px-[15px] py-[29px] gap-[15px] rounded-[10px] bg-[rgba(255,255,255,0.11)]
                     md:px-[26px]`,
    headerSection: `flex justify-between items-center ${styles.beforeShadow}`,
    buttonText:`text-[12px] 
                md:text-[16px]`,
    tokenDetails: `flex gap-2`,
    tokenDetailContainer: `rounded-full px-4 py-1 border border-primaryHeading`,
    detailsContainer: `flex flex-col gap-5 items-center justify-center min-h-[300px] bg-themeColor mt-5 rounded-[6px]`,
    deployedTokenDetails: `flex w-full bg-liveGamePrimaryColor text-center`,
    deployedTokenPlayerName: `border-r border-themeColor px-[6px] py-[10px] flex-1`,
    deployedTokenActionName: `px-[6px] py-[10px] flex-1`,
    buttonContainer: `flex justify-between mt-auto`,
    notDeployedImage: `w-full h-[auto] max-w-[300px]`

}

export { deployTokenStyles, previewGameStyles, tokenSelectorStyles, previewTokenStyles, selectActionAndPlayerStyles, poweredUpScreen };